import AppError from '@App/error/AppError';

export default class AccessDeniedError extends AppError {
    static CODE = 'access-denied';
}
